import React from "react";
import { Row, Col, Spin } from "@murm/ant";
import { CategoryButton } from "../components/CategoryButton";
import { FeatureButton } from "../components/FeatureButton";
import { BackButton } from "../components/BackButton";
import { CARD_COLUMNS, orderedCategories } from "../config/catalogContent";
import { useFeatureNavigation } from "../../../lib/dataCatalog/useFeatureNavigation";
import { useFetchFeatures } from "../../../lib/useFetchFeatures";
import { FeatureTypeConfig } from "../config/featureTypes";
import { MetricCard } from "../components/MetricCard";
import styles from "../DataCatalog.module.css";

const MetricsTab = ({ onMetricSelect, isItemSelected }) => {
  const {
    selectedCategory,
    selectedFeature,
    handleCategoryClick,
    handleFeatureClick,
    handleBack,
    handleDirectCategoryAndFeature,
    isDirectNavigation,
  } = useFeatureNavigation();

  // No in-catalog search box in the Explorer Figma (2a): every category is listed.
  const { categorizedFeatures: filteredFeatures, isLoading } = useFetchFeatures("/api/metrics");

  const handleMetricSelection = (metricItem) => {
    onMetricSelect(metricItem);
  };

  const handleCategoryOrFeatureClick = (category, features) => {
    if (
      features.length === 1 &&
      features[0].name === category &&
      features[0].type !== "estimate"
    ) {
      handleDirectCategoryAndFeature(category, features[0]);
    } else {
      handleCategoryClick(category);
    }
  };

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className={styles.tabBody}>
      {selectedCategory && (
        <BackButton
          onClick={handleBack}
          backTarget={
            selectedFeature && !isDirectNavigation
              ? selectedCategory
              : "Categories"
          }
        />
      )}

      {!selectedCategory ? (
        <Row gutter={[12, 12]}>
          {orderedCategories(filteredFeatures).map(([category, features]) => (
            <Col key={category} {...CARD_COLUMNS}>
              <CategoryButton
                category={category}
                onClick={() => handleCategoryOrFeatureClick(category, features)}
              />
            </Col>
          ))}
        </Row>
      ) : !selectedFeature ? (
        <Row gutter={[12, 12]}>
          {filteredFeatures[selectedCategory]?.map((feature) => {
            if (feature.type === "continuous") {
              return (
                <Col key={feature.name} {...CARD_COLUMNS}>
                  <MetricCard
                    title={feature.display || feature.name}
                    description={feature.description}
                    options={feature.available_aggregations}
                    hideOptions
                    onOptionSelect={(agg) => {
                      const metricItem = FeatureTypeConfig[
                        feature.type
                      ].createMetricItem(feature, agg);
                      handleMetricSelection(metricItem);
                    }}
                    isOptionSelected={(agg) => {
                      const metricItem = FeatureTypeConfig[
                        feature.type
                      ].createMetricItem(feature, agg);
                      return isItemSelected(metricItem, "metrics");
                    }}
                  />
                </Col>
              );
            }
            if (feature.type === "estimate") {
              console.log(feature);
              return (
                <Col key={feature.name} {...CARD_COLUMNS}>
                  <MetricCard
                    title={feature.display || feature.name}
                    description={feature.description}
                    options={feature.years}
                    onOptionSelect={(year) => {
                      const metricItem = FeatureTypeConfig[
                        feature.type
                      ].createMetricItem(feature, year);
                      handleMetricSelection(metricItem);
                    }}
                    isOptionSelected={(year) => {
                      const metricItem = FeatureTypeConfig[
                        feature.type
                      ].createMetricItem(feature, year);
                      return isItemSelected(metricItem, "metrics");
                    }}
                  />
                </Col>
              );
            }
            return (
              <Col key={feature.name} {...CARD_COLUMNS}>
                <FeatureButton
                  feature={feature.display || feature.name}
                  description={feature.description}
                  onClick={() => handleFeatureClick(feature)}
                  selected={false}
                />
              </Col>
            );
          })}
        </Row>
      ) : selectedFeature.type === "categorical" ? (
        <Row gutter={[12, 12]}>
          {selectedFeature.values?.map((value, idx) => (
            <Col key={value} {...CARD_COLUMNS}>
              <MetricCard
                title={selectedFeature.display_values[idx]}
                description={selectedFeature.description}
                options={selectedFeature.available_aggregations}
                hideOptions
                onOptionSelect={(agg) => {
                  const metricItem = FeatureTypeConfig[
                    selectedFeature.type
                  ].createMetricItem(selectedFeature, agg, {
                    key: value,
                    value: selectedFeature.display_values[idx],
                  });
                  handleMetricSelection(metricItem);
                }}
                isOptionSelected={(agg) => {
                  const metricItem = FeatureTypeConfig[
                    selectedFeature.type
                  ].createMetricItem(selectedFeature, agg, {
                    key: value,
                    value: selectedFeature.display_values[idx],
                  });
                  return isItemSelected(metricItem, "metrics");
                }}
              />
            </Col>
          ))}
        </Row>
      ) : null}
    </div>
  );
};

export { MetricsTab };
